import { AsyncState, HttpResult } from "widgets-for-react";
import { ItemWithDates } from "./date.state";

export const loadItems = async (): Promise<HttpResult<ItemWithDates[]>> => {
  const headers = new Headers()
  headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)
  headers.append('content-type', 'application/json')
  const res = await fetch('/api/v1/test-dates', {
    method: 'get',
    headers: headers,
    credentials: 'include'
  })
  if (!res.ok) {
    return {
      kind: "failed",
      status: res.status
    }
  }
  const deserializedResult = await res.json() as {
    id: string,
    createdDate: string,
    modifiedDate: string,
    dateTest: string
  }[]
  const items =
    deserializedResult.map((resultItem): ItemWithDates => ({
      id: resultItem.id,
      createdDate : new Date(resultItem.createdDate),
      dateTest: new Date(resultItem.dateTest),
      modifiedDate: new Date(resultItem.modifiedDate)
    }))
  return {
    kind: 'result',
    status: 200,
    value: items
  }
}

export const createItem = async (date: Date): Promise<HttpResult<void>> => {
  const headers = new Headers()
  headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)
  const res = await fetch(`/api/v1/test-dates?date=${date.toUTCString()}`, {
    method: 'post',
    headers: headers,
    credentials: 'include'
  })
  if (!res.ok) {
    return {
      kind: "failed",
      status: res.status
    }
  }
  return {
    kind: "result",
    status: 200,
    value: undefined
  }
}